import * as React from "react";
import { useEffect, useRef } from "react";
import { useRegistrationContext } from "../Contexts/RegistrationContext";
import "./SearchInfoButton.scss";

export const SearchInfoButton = (): JSX.Element => {
    const { searchInfoVisible, setSearchInfoVisible, toggleSearchInfo } = useRegistrationContext();

    const ref = useRef<HTMLButtonElement>();

    useEffect(() => {
        searchInfoVisible && ref.current && ref.current.focus();
    }, [searchInfoVisible]);

    return (
        <button
            ref={ref}
            id="search"
            className={`search-button unselectable ${searchInfoVisible && "active"}`}
            onClick={toggleSearchInfo}
            onBlur={() => setSearchInfoVisible(false)}
        >
            <span>?</span>
        </button>
    );
};
